import { motion } from "framer-motion";
import { TEST_IDS } from "@/constants/testIds";
import { useT } from "@/i18n/LanguageContext";

export const About = () => {
  const { t } = useT();
  const stats = t("about.stats");

  return (
    <section
      id="the-house"
      data-testid={TEST_IDS.about.root}
      className="relative py-28 md:py-40"
    >
      <div className="container-luxe">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-[11px] tracking-[0.4em] text-gold">
                {t("about.index")}
              </span>
              <div className="h-px w-12 bg-gold" />
              <span className="overline">{t("about.overline")}</span>
            </div>
            <h2
              data-testid={TEST_IDS.about.heading}
              className="h-display text-4xl md:text-5xl lg:text-6xl text-ink text-balance"
            >
              {t("about.title1")}
              <br />
              <span className="italic">{t("about.title2")}</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className="lg:col-span-7 lg:pt-6"
          >
            <p className="text-lg md:text-xl leading-relaxed text-ink/85 font-light">
              {t("about.lead")}
            </p>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-muted_text font-light">
              {t("about.body")}
            </p>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
              {stats.map((s) => (
                <div key={s.label} className="border-l border-ink/15 pl-4">
                  <div className="font-display text-2xl md:text-3xl text-ink leading-tight">
                    {s.value}
                  </div>
                  <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.28em] text-muted_text leading-snug">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
